// This file is automatically generated. Do not edit manually.

import { CustomAppAccess } from "src/api/generated/erp/customApps/runtime/customAppAccess";
import { CustomAppAvailableLauncher } from "src/api/generated/erp/customApps/runtime/customAppAvailableLauncher";
import { CustomFunctionUiActionContext } from "src/api/generated/erp/customFunctions/triggers/uiAction/context/customFunctionUiActionContext";
import { CustomAppDataAccess } from "src/api/generated/erp/customApps/runtime/customAppDataAccess";
import { CustomAppThreadDevBuild } from "src/api/generated/erp/customApps/runtime/customAppThreadDevBuild";
import { CustomAppDevBuildAccess } from "src/api/generated/erp/customApps/runtime/customAppDevBuildAccess";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomAppUserApi {
	export async function list(): Promise<Array<CustomAppUserApi_App>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customApps/user/list",
			method: "POST",
			data: {},
		});
		return response as Array<CustomAppUserApi_App>;
	}

	export async function createAccess(args: { customAppId: number }): Promise<CustomAppAccess> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customApps/user/createAccess",
			method: "POST",
			data: {
				customAppId: args.customAppId,
			},
		});
		return response as CustomAppAccess;
	}

	export async function getUiLaunchers(): Promise<Array<CustomAppAvailableLauncher>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customApps/user/getUiLaunchers",
			method: "POST",
			data: {},
		});
		return response as Array<CustomAppAvailableLauncher>;
	}

	export async function createLauncherAccess(args: {
		customAppId: number;
		launcherKey: string;
		context: CustomFunctionUiActionContext;
	}): Promise<CustomAppAccess> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customApps/user/createLauncherAccess",
			method: "POST",
			data: {
				customAppId: args.customAppId,
				launcherKey: args.launcherKey,
				context: args.context,
			},
		});
		return response as CustomAppAccess;
	}

	export async function createPreviewAccess(args: {
		customAppRevisionId: number;
		input: unknown;
	}): Promise<CustomAppAccess> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customApps/user/createPreviewAccess",
			method: "POST",
			data: {
				customAppRevisionId: args.customAppRevisionId,
				input: args.input,
			},
		});
		return response as CustomAppAccess;
	}

	export async function refreshDataAccess(args: { customAppRevisionId: number }): Promise<CustomAppDataAccess> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customApps/user/refreshDataAccess",
			method: "POST",
			data: {
				customAppRevisionId: args.customAppRevisionId,
			},
		});
		return response as CustomAppDataAccess;
	}

	export async function getThreadDevBuild(args: { threadId: string }): Promise<CustomAppThreadDevBuild | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customApps/user/getThreadDevBuild",
			method: "POST",
			data: {
				threadId: args.threadId,
			},
		});
		return response === "" ? null : (response as CustomAppThreadDevBuild | null);
	}

	export async function createDevBuildAccess(args: {
		customAppId: number;
		input: unknown;
	}): Promise<CustomAppDevBuildAccess> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customApps/user/createDevBuildAccess",
			method: "POST",
			data: {
				customAppId: args.customAppId,
				input: args.input,
			},
		});
		return response as CustomAppDevBuildAccess;
	}

	export async function refreshDevBuildDataAccess(args: { customAppId: number }): Promise<CustomAppDataAccess> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customApps/user/refreshDevBuildDataAccess",
			method: "POST",
			data: {
				customAppId: args.customAppId,
			},
		});
		return response as CustomAppDataAccess;
	}
}

export interface CustomAppUserApi_App {
	customAppId: number;
	name: string;
}
